import * as React from 'react';
import c from 'classnames';
import { useSelector, useStore } from 'react-redux';
import {
  selectDefaultSort,  
  selectAvailableSorting,
  changeDefaultSortAction,
} from '../../ducks';
import { documentSetCookie } from '../../cookie';
import commentsStyles from '../../css/_comments.css';
import { ClickElement } from '../form';
import styles from '../buttonswitch/ButtonSwitch.css';

export const Sorting = ({ isModerator, menuSorting }) => {
  const { dispatch } = useStore();
  const defaultSorting = useSelector(selectDefaultSort);
  const availableSorting = useSelector(selectAvailableSorting);

  const userSortingList = isModerator => {
    const sortingList = Array.from(availableSorting);
    const index = sortingList.findIndex(item => item === 'moderatorView');
    const normalUserList = [
      ...sortingList.slice(0, index),
      ...sortingList.slice(index + 1),
    ];
    const newSortingList = isModerator
      ? sortingList
      : normalUserList;
    return newSortingList;
  };

  const CommentsOptionsWrapper = ({ children }) => (
    <div className={styles.button_switch}>
      {children}
    </div>    
  );

  return(
    <>
      <div className={commentsStyles['comments-section']}>
        {(!isModerator && menuSorting) && (
          <CommentsOptionsWrapper>
            {userSortingList(false).map((item, index) => (
              <label className={c(styles.multi_switcher, {[styles.checked]: item === defaultSorting})}
                key={item + index}>
                <input type="radio" name="filterComments" checked={item === defaultSorting}
                  onChange={() => {
                    documentSetCookie('default_sort', item);
                    dispatch(changeDefaultSortAction(item));
                  }}/>

                <div className={styles.checker}></div>
                {{
                  'newestFirst': 'Nieuwste',
                  'mostKudosFirst': 'Meeste kudos',
                  'oldestFirst': 'Oudste',
                  'moderatorView': 'Moderator',
                }[item]}
              </label>
            ))}
          </CommentsOptionsWrapper>               
        )}
      </div>
      {isModerator && (
        <ClickElement
          text='Moderator view'
          ElementType="button"
          onClick={() => {
            documentSetCookie('default_sort', 'moderatorView');
            dispatch(changeDefaultSortAction('moderatorView'));
          }}
          primary={'moderatorView' === defaultSorting}
          secondary={'moderatorView' !== defaultSorting}
          id={commentsStyles.moderator}
          style={{ 'marginBottom': '0', 'outline': '0', 'fontSize': '9px', 'padding': '10px' }}
        />
      )
      }
    </>
  );
};